import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import FeedPostFront from '@/components/FeedPostFront'
import { FeedPostNotification } from '@/feed/Feed.interface'

interface IProps {
  sendImpressionStat: ({ campaignGuid }: { campaignGuid: string }) => void
  sendClickStat: ({
    campaignGuid,
    buttonNumber
  }: {
    campaignGuid: string
    buttonNumber: number
  }) => void
  sendInAppEvent: (inAppEvents: { name: string; occurredAt: string }[]) => void
  campaignGuid: string
  feedPostFront: FeedPostNotification['front']
  lastInteractionAt: number
}

function FeedItem({
  feedPostFront,
  sendImpressionStat,
  sendInAppEvent,
  campaignGuid,
  sendClickStat,
  lastInteractionAt
}: IProps) {
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      sendImpressionStat({ campaignGuid })
    }
  }, [inView, campaignGuid, sendImpressionStat])

  return (
    <div ref={ref}>
      <FeedPostFront
        sendClickStat={sendClickStat}
        sendInAppEvent={sendInAppEvent}
        campaignGuid={campaignGuid}
        feedPostFront={feedPostFront}
        lastInteractionAt={lastInteractionAt}
      />
    </div>
  )
}

export default FeedItem
